import IconLoader from "components/IconLoader/IconLoader";
import React from "react";

function RegisterMenu({ changeMultiplePageMode }) {
  const handleNewApplication = () => {
    const modeList = [
      { name: "registerForm", open: true },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: false },
      { name: "applicationList", open: false },
      { name: "examResults", open: false },
      { name: "registerMenu", open: false }
    ];
    changeMultiplePageMode(modeList)();
  };
  const openIdentityPage = () => {
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: true },
      { name: "validEntry", open: false },
      { name: "applicationList", open: false },
      { name: "examResults", open: false },
      { name: "registerMenu", open: false }
    ];
    changeMultiplePageMode(modeList)();
  };
  const handleExamResults = () => {
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: false },
      { name: "applicationList", open: false },
      { name: "examResults", open: true },
      { name: "registerMenu", open: false }
    ];
    changeMultiplePageMode(modeList)();
  };
  const handleApplicationList = () => {
    const modeList = [
      { name: "registerForm", open: false },
      { name: "identityCheck", open: false },
      { name: "validEntry", open: false },
      { name: "applicationList", open: true },
      { name: "examResults", open: false },
      { name: "registerMenu", open: false }
    ];
    changeMultiplePageMode(modeList)();
  };
  return (
    <>
      <div className="container h-100 pt-6" style={{ position: "relative" }}>
        <button
          onClick={openIdentityPage}
          className="btn btn-primary d-none d-lg-block"
          style={{ position: "absolute", left: -85 }}
        >
          <IconLoader icon="mdiChevronLeft" size={1} />
        </button>
        <div className="w-100 d-flex justify-content-center">
          <img src="/media/register/registerTitleImage.png" style={{ maxWidth: "100%" }} />
        </div>
        <div className="container h-100 registerMenu">
          <div className="row align-middle mt-10">
            <div className="col-lg-4 text-white cursor-pointer mt-4" onClick={handleNewApplication}>
              <div className="bg-info rounded px-10 py-10" style={{ minHeight: "14rem" }}>
                <label className="h5">SINAV</label>
                <br />
                <label className="h5">BAŞVURUSU YAP</label>
                <br />
                <p>Sınav başvurusu yapmak için tıklayınız.</p>
              </div>
            </div>
            <div
              className="col-lg-4 text-white cursor-pointer mt-4"
              onClick={handleApplicationList}
            >
              <div className="bg-primary rounded px-10 py-10" style={{ minHeight: "14rem" }}>
                <label className="h5">SINAV</label>
                <br />
                <label className="h5">BAŞVURULARIM</label>
                <br />
                <p>Sınav başvurularınızı görüntülemek için tıklayınız.</p>
              </div>
            </div>
            <div className="col-lg-4 text-white cursor-pointer mt-4" onClick={handleExamResults}>
              <div className="bg-success rounded px-10 py-10" style={{ minHeight: "14rem" }}>
                <label className="h5">SINAV</label>
                <br />
                <label className="h5">SONUÇLARIM</label>
                <br />
                <p>Sınav sonuçlarınızı görüntülemek için tıklayınız.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterMenu;
